import axios from 'axios';


export const actionTypes = (typeName, prefix = null) => {
  const name = prefix ? prefix + '_' + typeName : typeName;
  return {
    [typeName]: {
      START: `${name}_START`,
      SUCCESS: `${name}_SUCCESS`,
      ERROR: `${name}_ERROR`,
    },
  };
};


export const instance = axios.create({
  baseURL: `${window.location.origin}/${process.env.REACT_APP_BACKEND_FLOWABLE_CONTEXT_PATH}`,
  withCredentials: true,
});

export const documentKeys = payload => {
  const documentKeysList = [
    'investmentExpenses',
    'cumulativeDeclaration',
    'realBeneficiariesDeclaration',
    'beneficiariesRegistryPrint',
    'gemiCertificate',
    'otherDocuments',
    'cumulativeDeclaration',
    'taxFormE3',
    'realBeneficiariesDeclaration',
    'beneficiariesRegistryPrint',
    'gemiCertificate',
    'businessPlanFile',
    'eligibilityFile'
  ]
  return Object.keys(payload).filter(
    v => documentKeysList.includes(v)
  );
}

export const carrierKeys = payload => {
  const additionalCarrierKeysList = [
    'abiGcrCode',
    'companyName',
    'abiVat',
    'regDate',
    'mainKAD',
    'mainKADDescription',
    'companyLegalType',
    'companySize',
    'abiStreetFull',
    'abiStreet',
    'abiTk',
    'abiPerfecture',
    'birthDate',
    'abiDistrict',
    'invMob',
    'invMail',
    'legalSurname',
    'legalFather',
    'legalAdt',
    'legalName',
    'legalVat',
    'legalPhone',
    'legalPhoneValidated',
    'legalVat',
    'legalEmail',
    'legalEmailValidated',
    'legalPhoneMobile',
    'legalPhoneMobileValidated',
    'contactSurname',
    'contactName',
    'contactVat',
    'contactPhone',
    'contactPhoneValidated',
    'contactVat',
    'contactEmail',
    'contactEmailValidated',
    'buildDistrict',
    'buildAddress',
    'buildStreet',
    'buildCity',
    'buildTk',
    'buildPerfecture',
    'buildMunicipalityName',
    'kaek',
    'existCon',
    'connNum',
    'carrierBeneficiaries',
    'carrierShareHolders',
    'carrierShareHolders2',
    'addresses',
    'totalAmountSorefsis',
    'otherReasonCheck',
    'otherReasonDescription',
    'checkUniqueAfm',
    'checkUniqueKaek',
    'contactPersonFlag',
    'otherShareholdersFlag',
    'otherShareholdersFlag2',
    'singleCompanyFlag',
    'singleCompanies',
    'coverid',
    'rejectKtpReason',
    'rejectKtpMessage',
    'businessSize',
    'rejectBeneficiaryReason',
    'rejectBeneficiaryMessage',
    'providerReturnDate',
    'providerReturnComments',
    'carrierUsers',
    'hasShareholdersFlag',
    'bnkBank',
    'dapanesEpendysis',
    'initiator',
    'opMonths',
    'roomsNum',
    'complPerc',
    'roomsAvg',
    'estQuantity',
    'avgSalePrice',
    'activityField',
    'investmentFinancing',
    'investmentFinancingValue',
    'otherInvestmentFinancing',
    'otherInvestmentFinancingValue',
    'carrierBeneficiaries',
    'parseFlag',
    'totalEstimate',
    'commercialLoan',
    'loan',
    'totalEstimatePercentage',
    'commercialLoanPercentage',
    'loanPercentage',
    'totalCapex',
    'bnkSyndLoan'
  ];
  return Object.keys(payload).filter(
    v => v.startsWith('abi') || additionalCarrierKeysList.includes(v)
  );
};


export const termsKeys = payload =>
  Object.keys(payload).filter(
    v => v.startsWith('term')
  );

export const xedmKeys = payload =>
  Object.keys(payload).filter(
    v => v.startsWith('details')
  );

export const objectionInvestorKeys = payload => {
  return Object.keys(payload.variables).filter(v => v.startsWith('objInv'));
};

export const objectionCommitteeKeys = payload => {
  return Object.keys(payload.variables).filter(v => v.startsWith('objCommittee'));
};



export const projectPlanInfoKeys = payload => {
  const additionalProjectPlanInfoKeysList = ['projectPlans', 'messages', 'timestamp'];
  return Object.keys(payload).filter(v =>
    additionalProjectPlanInfoKeysList.includes(v)
  );
};



